export const CANCEL_PERSON_TEAM_EDIT_STATE = "cancelPersonTeamEditState";
export const DELETE_TEAM = "deleteTeam";
export const FETCH_PERSON_TEAM = "fetchPersonTeam";
export const SAVE_PERSON_TEAM = "savePersonTeam";
export const SAVE_TEAM = "saveTeam";
export const UPDATE_TEAM = "updateTeam";
